import React, { useRef, useState } from 'react';
import { Upload, CheckCircle2, XCircle, Loader2 } from 'lucide-react';

const ACCEPT = '.pdf,.jpg,.jpeg,.png,.tiff,.tif,.webp';

const STATUS_ICON = {
  pending: <Loader2 size={14} className="spin" />,
  uploading: <Loader2 size={14} className="spin" />,
  done: <CheckCircle2 size={14} className="ok" />,
  error: <XCircle size={14} className="err" />,
};

export default function UploadZone({ onUpload, uploads, onClear }) {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  const handleFiles = (fileList) => {
    if (!fileList || fileList.length === 0) return;
    onUpload(Array.from(fileList));
  };

  const onDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };
  const onDragLeave = () => setDragOver(false);
  const onDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    handleFiles(e.dataTransfer.files);
  };

  return (
    <div className="upload-section">
      <div
        className={`drop-zone ${dragOver ? 'dragover' : ''}`}
        onClick={() => inputRef.current?.click()}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        role="button"
        tabIndex={0}
      >
        <Upload size={20} />
        <span>Belege hier ablegen oder klicken zum Auswählen</span>
        <span className="muted small">PDF, JPG, PNG, TIFF, WEBP — max 25 MB</span>
        <input
          ref={inputRef}
          type="file"
          accept={ACCEPT}
          multiple
          style={{ display: 'none' }}
          onChange={(e) => {
            handleFiles(e.target.files);
            e.target.value = ''; // allow re-select of same file
          }}
        />
      </div>

      {uploads.length > 0 && (
        <div className="upload-list">
          <div className="upload-list-header">
            <span className="muted small">{uploads.length} Datei(en)</span>
            <button className="btn-text small" onClick={onClear}>Liste leeren</button>
          </div>
          {uploads.map((u, i) => (
            <div key={i} className={`upload-item upload-${u.status}`}>
              {STATUS_ICON[u.status]}
              <span className="upload-name">{u.name}</span>
              {u.message && <span className="muted small">{u.message}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
